import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { useDiscountOffer } from "../hooks/usePubDiscountOffers";
import { Box, Flex, HStack, Text, Image, Spinner } from "@chakra-ui/react";
import { DiscountOffersbgLinearGradient, setDiscountImageUrl, } from "../shared-utils/utils";
import { capitalizeFirstChar } from "./common/util";
import { IMG_URL } from "./common/Constant";
const PubOffersSection = React.memo(({ pub_id }) => {
    var _a;
    const { data, isLoading, isError, error } = useDiscountOffer(pub_id);
    const offers = ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.offers) || [];
    const filteredOffers = useMemo(() => offers.filter((offer) => offer.offerCategory !== "INSTANT"), [offers]);
    const parseDescription = (description, offer) => {
        const regexParts = [
            /(?<=\w\s?)for [R₹]s?\s?\d+/,
            /(?<=\w+\s)get \d+ Free/,
            /(?<=\w+\s)get free/,
            /\d+\s?% discount/,
            /[R₹]s?\s?\d+/,
            /Flat [R₹]s?\s?\d+ off/,
            /\d+\s?% off/,
            /1 Free/,
            /(?<=\w+\s)free/, // Matches "free" preceded by a word and space
        ];
        const regex = new RegExp(regexParts.map((r) => r.source).join("|"), "gi");
        const match = description.match(regex);
        if (match) {
            const heading2 = match[0];
            const index = description.indexOf(heading2);
            const heading1 = description.slice(0, index).trim();
            const heading3 = description.slice(index + heading2.length).trim();
            return { heading1, heading2, heading3 };
        }
        if (offer.discountPercentage && offer.discountPercentage > 0) {
            return {
                heading1: "Enjoy",
                heading2: `${offer.discountPercentage}% OFF`,
                heading3: description,
            };
        }
        else if (offer.discountAmount && offer.discountAmount > 0) {
            return {
                heading1: "Save",
                heading2: `Flat ₹${offer.discountAmount} off`,
                heading3: description,
            };
        }
        else if (offer.offerPrice && offer.offerPrice > 0) {
            return {
                heading1: "Special Price",
                heading2: `₹${offer.offerPrice}`,
                heading3: description,
            };
        }
        return {
            heading1: "Get",
            heading2: "Great Offer",
            heading3: description,
        };
    };
    return (_jsx(_Fragment, { children: isLoading ? (_jsx(Box, { textAlign: "center", children: _jsx(Spinner, { color: "white" }) })) : isError || !offers || offers.length === 0 ? null : (_jsx(Box, { width: "100%", px: 4, children: _jsxs(Box, { borderRadius: "10px", bg: "#1E1E1E", p: 4, color: "white", width: "100%", children: [_jsx(HStack, { spacing: 4, overflowX: "auto", mb: 3, children: filteredOffers.map((offer) => {
                            const { heading1, heading2, heading3 } = parseDescription(offer.description, offer);
                            return (_jsxs(Box, { borderRadius: "10px", bg: DiscountOffersbgLinearGradient(offer.offerCategory), minWidth: "200px", maxWidth: "200px", h: "110px", p: 3, display: "flex", flexDirection: "column", position: "relative", children: [_jsx(Text, { fontSize: "xs", color: "#EBBB79", children: offer.name }), _jsxs(Flex, { direction: "column", mt: 2, children: [_jsx(Text, { fontSize: "10px", children: capitalizeFirstChar(heading1) }), _jsx(Text, { fontSize: "xl", fontWeight: "bold", transform: "scaleY(0.75)", lineHeight: 1, children: heading2.toUpperCase() }), _jsx(Text, { fontSize: "12px", children: capitalizeFirstChar(heading3) })] }), _jsx(Image, { src: setDiscountImageUrl(offer.offerCategory), alt: `${offer.offerCategory}`, height: "45px", width: "60px", position: "absolute", right: 0, bottom: 0 })] }, offer.id));
                        }) }), _jsxs(Box, { display: "flex", h: "75px", w: "100%", borderRadius: "10px", overflow: "hidden", bgImage: `url('${IMG_URL}/icons/offer_banner.png')`, bgSize: "cover", bgPosition: "center", bgRepeat: "no-repeat", justifyContent: "center", alignItems: "center", flexDirection: "column", children: [_jsx(Text, { transform: "translateX(20px)", fontSize: "sm", color: "white", children: "Offers available through" }), _jsx(Text, { transform: "translateX(20px)", fontSize: "sm", color: "white", children: "Zillout bookings only!" })] })] }) })) }));
});
export default PubOffersSection;
